import script from "./VenueBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./VenueBanner.vue?vue&type=script&setup=true&lang=js"

import "./VenueBanner.vue?vue&type=style&index=0&id=1e6d4aa5&lang=scss"

const __exports__ = script;

export default __exports__